<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="projectName"
          size="small"
          @keydown.enter.native="search"
          @clear="search"
          placeholder="请输入项目名称或备注进行搜索..."
          clearable
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
          size="small"
          >搜索</el-button
        >

        <!-- 采购支付日期区间筛选（与其它项目管理页面保持一致） -->
        <el-date-picker
          v-model="rqScope"
          style="margin-left: 10px"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          @change="onDateChange"
        >
        </el-date-picker>
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button type="success" @click="downloadExcel" size="small">
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >采购成本录入|退款</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="buyData"
        stripe
        border
        :row-style="{ height: '58px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        fit
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <el-table-column
          prop="bm"
          label="项目编码"
          fixed
          align="center"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          fixed
          align="center"
          width="250"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="costType"
          label="成本类型"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.costType || '--' }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="rq"
          label="采购支付日期"
          align="center"
          width="145"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="采购支付金额"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.buyMoney - b.buyMoney;
            }
          "
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.buyMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bz" label="备注" align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="录入人员"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="checkUserName"
          label="复核人员"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.isCheck === "1" ? scope.row.checkUserName : "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期" align="center" sortable width="120" :formatter="dateTimeTwoLine" class-name="cell-two-line">
        </el-table-column>
        <el-table-column prop="updateTime" label="修改日期" align="center" sortable width="120" :formatter="dateTimeTwoLine" class-name="cell-two-line">
        </el-table-column>

        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="285"
          v-if="qx"
        >
          <template slot-scope="scope">
            <template v-if="userId != scope.row.userId">
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.isCheck === '0'"
                @click="reCheck(scope.row.id, 1)"
              >
                复核
              </el-button>
              <el-button
                type="warning"
                size="mini"
                v-else
                @click="reCheck(scope.row.id, 0)"
              >
                撤销复核
              </el-button>
            </template>

            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              :disabled="
                kaiguan(scope.row.createTime) || scope.row.isCheck === '1'
              "
              @click="showEditView(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="
                kaiguan(scope.row.createTime) || scope.row.isCheck === '1'
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;
        "
      >
        <div>采购支付金额合计（当前页）: {{ moneyNumber(buyTotal) }}</div>
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page"
          :page-size="limit"
          :page-sizes="[10, 20, 50, 100, 200]"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="margin-bottom: 12px">
        <el-switch
          v-model="flag"
          active-color="#aaaaff"
          inactive-color="#ff4949"
          active-text="采购成本"
          inactive-text="退款"
        >
        </el-switch>
      </div>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="inputObj.projectId"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="biaoqian1" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- <el-col :span="12">
              <el-form-item label="成本类型" prop="costType">
                <el-select
                  v-model="inputObj.costType"
                  placeholder="请选择"
                  size="mini"
                  style="width: 250px"
                >
                  <el-option label="货物" value="货物"></el-option>
                  <el-option label="服务" value="服务"></el-option>
                </el-select>
              </el-form-item>
              
            </el-col>  -->

            <el-col :span="12">
              <el-form-item label="合计金额" prop="buyMoney">
                <el-input
                  type="number"
                  size="mini"
                  style="width: 250px"
                  v-model="inputObj.buyMoney"
                  placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注信息" prop="bz">
                <el-input
                  type="text"
                  size="mini"
                  style="width: 250px"
                  v-model="inputObj.bz"
                  placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
            
          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import { kz } from "../../utils/MyFunction";

export default {
  name: "ProjBuy",
  data() {
    return {
      qx: true, // 总经理、销售总监编辑的权限
      title: "",
      flag: true,
      xmShow: false,
      buyData: [], // 存放查询结果
      loading: false,
      total: 0,
      buyTotal: 0, // 采购支付金额合计（仅统计当前页返回的数据）
      page: 1,
      limit: 50,
      projectName: "",
      rqScope: [], // 采购支付日期区间（绑定日期控件，提交时拆成 rqBegin/rqEnd）
      queryRqBegin: "", // 查询用：采购支付日期起
      queryRqEnd: "", // 查询用：采购支付日期止
      dialogVisible: false,
      // 新增采购对象
      inputObj: {
        id: null,
        projectId: null,
        rq: "",
        goodsCode: "",
        price: null,
        quantity: null,
        buyMoney: null,
      },
      projects: [], //项目id-项目名称下拉框
      goods: [], // 采购商品 下拉框
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择项目名称",
            trigger: "blur",
          },
        ],
        // costType: [
        //   {
        //     required: true,
        //     message: "请选择成本类型",
        //     trigger: "blur",
        //   },
        // ],
        rq: [
          {
            required: true,
            message: "请选择日期",
            trigger: "blur",
          },
        ],
        // goodsCode: [{
        // 	required: true,
        // 	message: '请选择货品',
        // 	trigger: 'blur'
        // }],
        // price: [{
        // 	required: true,
        // 	message: '请输入单价,大于0',
        // 	trigger: 'blur'
        // }],
        // quantity: [{
        // 	required: true,
        // 	message: '货品数量: 正数为采购，负数为退货！',
        // 	trigger: 'blur'
        // }]
        buyMoney: [
          {
            required: true,
            message: "请输入采购金额",
            trigger: "blur",
          },
        ],
        bz: [
          {
            required: true,
            message: "请输入备注信息",
            trigger: "blur",
          },
        ],
      },
      userId: sessionStorage.getItem("uid"),
    };
  },
  mounted() {
    // this.quanxian()
    this.initBuy();
    this.initDim();
    this.quanxian();
  },
  computed: {
    biaoqian1() {
      if (this.flag == true) {
        return "采购日期";
      } else {
        return "退款日期";
      }
    },
    // minValue() {
    // 	if ( this.flag == true) {  // 采购
    // 		return 1
    // 	} else {                   // 退货
    // 		return -99999
    // 	}
    // },
    // maxValue() {
    // 	if ( this.flag == true) {
    // 		return 99999
    // 	} else {
    // 		return -1
    // 	}
    // },
    // myinput() {
    // 	var res =""
    // 	if ( this.flag == true) {  // 采购
    // 		res = "if(value<1) value=0 "
    // 	} else {                   // 退货
    // 		res = "if(value>-1) value=0 "
    // 	}
    // 	return res
    // }
  },
  methods: {
    // 复核操作
    reCheck(id, isCheck) {
      let tipText = isCheck === 1 ? "是否复核此条录入信息?" : "是否撤销复核?";
      this.$confirm(tipText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.postRequest2("/project/buy_check", { id, isCheck }).then((res) => {
          if (res.code === 200) {
            this.initBuy();
          }
        });
      });
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
        // 销售(角色id 2)只读：隐藏"添加"按钮与整个操作列
        if (this.doesItContain([2]).length > 0) {
          this.qx = false;
        }
      }
    },

    moneyNumber(val) {
      // 与"借款管理"统计保持一致：全角￥ + 数字（无千分位，最多 2 位小数）
      return "￥" + Number(Number(val || 0).toFixed(2));
    },
    // ==================== 导出 Excel（exceljs，数据驱动，不读 DOM） ====================
    // 文件名用的日期后缀：YYYYMMDD
    exportFileDate() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
    },
    // 列表查询与导出共用同一套筛选参数，避免两处拼参不一致
    buildBuyUrl(page, limit) {
      let url =
        "/project/buy_list?page=" +
        page +
        "&limit=" +
        limit +
        "&projectName=" +
        encodeURIComponent(this.projectName);
      // 采购支付日期区间
      if (this.queryRqBegin) url += "&rqBegin=" + this.queryRqBegin;
      if (this.queryRqEnd) url += "&rqEnd=" + this.queryRqEnd;
      return url;
    },
    // 导出列定义：页面表格列去掉"操作"列与创建日期/修改日期（业务确认导出不需要时间列）
    // 注意：页面表格仍保留创建/修改日期列，仅导出不含；不要顺手加回来。
    getExportColumns() {
      return [
        { header: "项目编码", key: "bm", width: 18 },
        { header: "项目名称", key: "projectName", width: 36, align: "left" },
        { header: "采购支付日期", key: "rq", width: 16 },
        { header: "采购支付金额", key: "buyMoney", width: 15, money: true },
        { header: "备注", key: "bz", width: 24, align: "left" },
        { header: "录入人员", key: "userName", width: 12 },
        { header: "复核人员", key: "checkUserName", width: 12 },
      ];
    },
    // 用数据数组生成 Excel（exceljs 体积较大，动态导入，仅在点击导出时加载）
    // rows      - 要导出的数据数组
    // fileName  - 文件名，如 "项目采购录入_20260212.xlsx"
    // sheetName - 工作表名，默认取文件名去掉扩展名
    async exportRowsToExcel(rows, fileName, sheetName) {
      const mod = await import(/* webpackChunkName: "exceljs" */ "exceljs");
      // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
      const ExcelJS =
        mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
      const columns = this.getExportColumns();

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, "")
      );

      // 列定义（表头行由 columns.header 自动生成）
      sheet.columns = columns.map((col, i) => ({
        header: col.header,
        key: "c" + i,
        width: col.width,
      }));

      const thin = { style: "thin", color: { argb: "FFD0D0D0" } };

      // 表头样式：加粗 + 灰底 + 居中 + 边框
      const headerRow = sheet.getRow(1);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFEEF1F6" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: thin, left: thin, bottom: thin, right: thin };
      });

      // 冻结首行：滚动时表头常驻
      sheet.views = [{ state: "frozen", ySplit: 1 }];

      // 数据行
      (rows || []).forEach((row) => {
        const values = columns.map((col) => {
          const raw = col.format ? col.format(row) : row[col.key];
          // 空值写成真正的空单元格，不写 "--"，避免影响 Excel 求和
          if (raw === null || raw === undefined || raw === "") return null;
          if (col.money) {
            const n = Number(raw);
            return isNaN(n) ? null : n;
          }
          return raw;
        });
        const added = sheet.addRow(values);

        columns.forEach((col, i) => {
          const cell = added.getCell(i + 1);
          cell.border = {
            top: { style: "thin", color: { argb: "FFE8E8E8" } },
            left: { style: "thin", color: { argb: "FFE8E8E8" } },
            bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
            right: { style: "thin", color: { argb: "FFE8E8E8" } },
          };
          if (col.money) {
            // 千分位 + 两位小数；保留数值类型，可在 Excel 中继续排序/求和
            cell.numFmt = "#,##0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = {
              horizontal: col.align || "center",
              vertical: "middle",
            };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    },
    // 导出入口：按当前筛选条件拉全量数据后直接生成 Excel（不渲染表格，无需还原分页状态）
    downloadExcel() {
      const EXPORT_LIMIT = 99999; // 用超大 limit 让服务端返回"筛选后的全部记录"
      const fileName = "项目采购录入_" + this.exportFileDate() + ".xlsx";
      this.loading = true;
      this.getRequest(this.buildBuyUrl(1, EXPORT_LIMIT))
        .then((resp) => {
          this.loading = false;
          const rows = (resp && resp.data) || [];
          if (!rows.length) {
            this.$message({
              type: "warning",
              message: "当前筛选条件下没有数据",
            });
            return;
          }
          return this.exportRowsToExcel(rows, fileName).catch((e) => {
            console.log(e);
            this.$message({ type: "error", message: "导出失败，请重试" });
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    kaiguan(sj) {
      var sf = kz(sj);
      return sf;
    },
    sumMoney() {
      this.inputObj.buyMoney = this.inputObj.price * this.inputObj.quantity;
    },
    doChance() {
      this.dialogVisible = false;
      this.initBuy();
      this.flag = true;
    },
    showEditView(data) {
      this.title = "编辑采购成本|退款";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      this.$confirm(
        "此操作将永久删除 " + data.projectName + "的该条采购明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/project/buy_delete?id=" + data.id).then(
            (resp) => {
              if (resp) {
                this.initBuy();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/project/buy_update", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initBuy();
                }
              }
            );
          }
        });
      } else {
        // 添加
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/project/buy_add", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initBuy();
                }
              }
            );
          }
        });
      }
      // this.dialogVisible = false
    },
    initDim() {
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project").then((resp) => {
          if (resp) {
            this.projects = resp.result;
            this.saveDictCache("projects", resp.result);
          }
        });
      } else {
        this.projects = this.dictCache("projects");
      }
      if (!window.sessionStorage.getItem("goods")) {
        this.postRequest("/dim/dim_table_char/goods_code").then((resp) => {
          if (resp) {
            this.goods = resp.result;
            this.saveDictCache("goods", resp.result);
          }
        });
      } else {
        this.goods = this.dictCache("goods");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initBuy();
    },
    sizeChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.initBuy();
    },
    // 条件查询：回到第 1 页再查，避免停留在超出结果范围的页码上
    search() {
      this.page = 1;
      this.initBuy();
    },
    // 采购支付日期区间变化：拆成起止日期后查询
    onDateChange(val) {
      if (val && val.length === 2) {
        this.queryRqBegin = val[0];
        this.queryRqEnd = val[1];
      } else {
        this.queryRqBegin = "";
        this.queryRqEnd = "";
      }
      this.search();
    },
    showAddView() {
      this.title = "添加采购成本|退款";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        id: null,
        projectId: null,
        rq: "",
        goodsCode: "",
        price: null,
        quantity: null,
        buyMoney: null,
        bz: "",
        // createTime: null,
        // updateTime: null
      };
    },
    initBuy() {
      this.loading = true;
      const url = this.buildBuyUrl(this.page, this.limit);
      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          this.buyData = resp.data;
          this.total = resp.count;
          // 合计（当前页）：只累加本次返回的数据，翻页/改每页条数/筛选后重新计算
          this.buyTotal = 0;
          (resp.data || []).forEach((item) => {
            this.buyTotal = Number(
              (this.buyTotal + Number(item.buyMoney || 0)).toFixed(2)
            );
          });
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.removeItem("projects");
    next();
  },
};
</script>

<style></style>
